export enum SportsLayout {
    EUROPEAN = 'EUROPEAN',
    AMERICAN = 'AMERICAN',
}
